var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1C7.05622 1 1 7.05622 1 14.5C1 21.9438 7.05571 28 14.5 28C21.9443 28 28 21.9438 28 14.5C28 7.05622 21.9443 1 14.5 1ZM14.5 26.4927C7.88703 26.4927 2.50733 21.113 2.50733 14.5C2.50733 7.88703 7.88754 2.50733 14.5 2.50733C21.1125 2.50733 26.4927 7.88703 26.4927 14.5C26.4927 21.113 21.1125 26.4927 14.5 26.4927V26.4927Z",
    fill: "#3C69AC",
    stroke: "#3C69AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.321 14.5439V6.98818C15.321 6.58055 14.9695 6.25 14.5355 6.25C14.1015 6.25 13.75 6.58053 13.75 6.98818V14.8497C13.75 15.0455 13.8327 15.2332 13.98 15.3717L18.4091 19.5339C18.5624 19.6779 18.7635 19.75 18.9646 19.75C19.1656 19.75 19.3665 19.678 19.5198 19.5339C19.8267 19.2455 19.8267 18.7782 19.5198 18.4898L15.321 14.5439Z",
    fill: "#3C69AC",
    stroke: "#3C69AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9983b948.svg";
export { ForwardRef as ReactComponent };